import { ReactNode } from "react";

export const getSalesChannelIconRaw = (salesChannel: string): string | ReactNode => {
    switch (salesChannel?.toLowerCase()) {
        case "shopify":
            return "https://storage.googleapis.com/heysynth_files/synth_webapp/shopify_w87tn3.svg";
        case "amazon":
            return "https://storage.googleapis.com/heysynth_files/synth_webapp/amazon_1_aeftdf.svg";
        default:
            return <i className="ri-store-2-fill text-y-10 text-base"></i>;
    }
};
